module.exports = __webpack_public_path__ + "img/musosem.0bc5c6c1.png";